import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpErrorResponse,
  HttpEvent,
  HttpResponse,
} from '@angular/common/http';

import {
  catchError,
  finalize,
  Observable,
  of,
  tap,
  throwError,
} from 'rxjs';

import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from '@app/services/auth-service.service';
import { LoaderService } from '@app/services/loader.service';
import { Router } from '@angular/router';
import { ToastService } from '@app/services/toast.service';
import { ConnectivityService } from '@app/services/connectivity.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private authService: AuthServiceService,
    private toastr: ToastrService, private toast: ToastService,
    private loader: LoaderService, private router: Router,
    private connectivity: ConnectivityService
  ) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this.authService.isLoggingOut) {
      return of(); // drop request
    }

    // 🚫 APIs jahan loader & token nahi chahiye
    const skipAuth =
      req.url.includes('organization-city-change') ||
      req.url.includes('reset-password');

    if (!skipAuth) {
      const authToken = this.authService.getToken;
      if (authToken) {
        req = req.clone({
          setHeaders: {
            Authorization: 'Bearer ' + authToken,
          },
        });
      }
      const currentUrl = window.location.href;

      const isDashboard = currentUrl.includes('dashboard');
      const isOrdersPage = currentUrl.includes('/orders') || currentUrl.includes('archive-orders');
      const isDriverListingPage = currentUrl.includes('/driver');
      const isBulkOrderPage = currentUrl.includes('bulk-order');
      const isAddressListingPage = currentUrl.includes('/address');
      const isWarehouseListingPage = currentUrl.includes('/warehouse');
      const isCompanyListingPage = currentUrl.includes('/companies');
      const isTicketListingPage = currentUrl.includes('/ticket');
      const isNotificationListingPage = currentUrl.includes('/send-notification');
      // const isProfilePage = currentUrl.includes('/profile');
      const isLocateDriverPage = currentUrl.includes('locate-driver');
      const isSettingsPage = currentUrl.includes('setting');
      const isAnalyticsPage = currentUrl.includes('analytics');
      const isBetaFeedback = currentUrl.includes('beta-feedback');

      const isOrderCountsApi = req.url.includes('company/order-counts');
      const isCompanyAddressFilter = req.url.includes('company/company-addres-filter');
      const isOrderManipApi = req.url.includes('company/order/') || req.url.includes('company/add-bulk-order');
      const isActiveDriverApi = req.url.includes('company/active-driver-listing'); // Prevent modal from freezing background

      if (
        !isDashboard &&
        !isOrdersPage &&
        !isDriverListingPage &&
        !isBulkOrderPage &&
        !isAddressListingPage &&
        !isWarehouseListingPage &&
        !isCompanyListingPage &&
        !isTicketListingPage &&
        !isNotificationListingPage &&
        // !isProfilePage &&
        !isLocateDriverPage &&
        !isSettingsPage &&
        !isAnalyticsPage &&
        !isBetaFeedback &&
        !isOrderCountsApi &&
        !isCompanyAddressFilter &&
        !isOrderManipApi &&
        !isActiveDriverApi
      ) {
        this.loader.show();
      }

    }

    return next.handle(req).pipe(

      tap(evt => {
        if (evt instanceof HttpResponse) {

          if (evt.body?.resultCode == 4) {
            this.authService.resultCodeError(evt.body);
          }

          if (evt.body?.resultCode == 3) {
            this.authService.doLogout();
          }
        }
      }),

      catchError((error: HttpErrorResponse) => {
        const skipToast = req.headers.get('X-Skip-Global-Toast') === 'true';
        if (!skipToast) {
          // status === 0 is common for aborted requests or real network failure
          // We only toast if it's likely a real failure (not an abort)
          if (error.status === 401) {
            this.toast.show('error', 'Your session has expired. Please login again.');
            this.authService.doLogout();
          } else if (error.status === 0 && !this.connectivity.isOnline) {
            this.toast.show('error', "No Internet Connection: Please check your network and try again.");
          } else if (error.status === 500) {
            this.toast.show('error', "Server Error: We're having trouble processing your request. Please try again or contact support if the issue persists.");
          }
        }
        return throwError(() => error);
      }),

      finalize(() => {
        if (!skipAuth) {
          this.loader.hide();
        }
      })
    );
  }
}
